module.exports = __webpack_public_path__ + "img/Symbol_9.7fc0885d.png";